import React, { useRef } from 'react';
import SelectableCard from '../SelectableCard';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function SelectableCardPlaceholderElement({ maxWidth = 100 }: { maxWidth?: number }) {
  const width = useRef(Math.floor(Math.random() * maxWidth) + maxWidth);
  return (
    <SelectableCard
      card={{
        ctx: {},
        title: <Skeleton width={width.current} />,
      }}
    >
      <SelectableCard.Image alt="Gribble" />
      <SelectableCard.Body>
        <SelectableCard.Title />
      </SelectableCard.Body>
    </SelectableCard>
  );
}

export const SelectableCardPlaceholder = React.memo(SelectableCardPlaceholderElement);
